// ... existing code ...
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Shop from "../pages/shop/page";
import SubscribeTrial from "../pages/subscribe-trial/page";
import VIPSubscribe from "../pages/vip-subscribe/page";
import Orders from "../pages/orders/page";
import Dashboard from "../pages/dashboard/page";
import Admin from "../pages/admin/page";
import Withdrawal from "../pages/withdrawal/page";
import WithdrawalRestricted from "../pages/withdrawal-restricted/page";
import AccountFrozen from "../pages/account-frozen/page";
import AccountDisabled from "../pages/account-disabled/page";
import ProductDetail from "../pages/product-detail/page";
import Profile from "../pages/profile/page";
import SubscriptionMode from "../pages/subscription-mode/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <Shop />,
  },
  {
    path: "/subscribe-trial",
    element: <SubscribeTrial />,
  },
  {
    path: "/vip-subscribe",
    element: <VIPSubscribe />,
  },
  {
    path: "/orders",
    element: <Orders />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/admin/verifications",
    element: <Admin />,
  },
  {
    path: "/withdrawal",
    element: <Withdrawal />,
  },
  {
    path: "/withdrawal-restricted",
    element: <WithdrawalRestricted />,
  },
  {
    path: "/account-frozen",
    element: <AccountFrozen />,
  },
  {
    path: "/account-disabled",
    element: <AccountDisabled />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/subscription-mode",
    element: <SubscriptionMode />,
  },
  {
    path: "/product/:productId",
    element: <ProductDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;